import { z } from 'zod';

export const CreateOrderSchema = z.object({
   productItems: z.array(
      z.object({
         productItemId: z.string(),
         quantity: z.number(),
      })
   ),
   paymentType: z.string(),
   coinflowPaymentId: z.string().nullable(),
});
